import script from "./OrdersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&setup=true&lang=js"

import "./OrdersComponent.vue?vue&type=style&index=0&id=74eba037&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74eba037"]])

export default __exports__